<template>
  <template v-if="resolvedIcon && resolvedIcon.icon">
    <template v-if="resolvedIcon.type === 'volvo'">
      <component
        :id="getIconValue(icon)"
        :is="resolvedIcon.icon"
        :type="getIconValue(icon)"
        :class="$attrs.class + ' widget-icon'"
        :data-icon-name="icon"
      ></component>
    </template>
    <template v-if="resolvedIcon.type === 'component'">
      <component
        :is="resolvedIcon.icon"
        v-bind="$attrs"
        :class="$attrs.class + ' widget-icon'"
        :data-icon-name="icon"
      ></component>
    </template>
    <div
      v-else-if="resolvedIcon.type === 'svg'"
      v-html="resolvedIcon.icon"
      class="widget-icon"
      :data-icon-name="icon"
    ></div>
    <Icon
      v-else-if="resolvedIcon.type === 'iconify'"
      :icon="resolvedIcon.icon"
      :data-icon-name="icon"
      v-bind="$attrs"
      :class="$attrs.class + ' widget-icon'"
    >
    </Icon>
  </template>
</template>

<script setup lang="ts">
  import { Icon } from '@iconify/vue';
  import { defineAsyncComponent, markRaw, computed } from 'vue';
  import { themeIcons } from 'src/utils/config';

  const props = defineProps<{ icon?: string }>();
  const resolvedIcon = computed(() => resolveIcon(getIconValue(props?.icon)));

  function getIconValue(icon: string | undefined) {
    if (!icon) return;
    if (themeIcons.value[icon as keyof typeof themeIcons.value]) {
      return themeIcons.value[icon as keyof typeof themeIcons.value];
    }
    return icon;
  }

  function resolveIcon(icon: string | undefined) {
    if (!icon) {
      return;
    }
    if (icon.endsWith('.vue')) {
      if (icon.startsWith('jaguar/')) {
        return {
          type: 'component',
          icon: markRaw(
            defineAsyncComponent(
              () =>
                import(
                  `../claims-widget/components/illustration/jaguar/${icon
                    .replaceAll('.vue', '')
                    .replaceAll('jaguar/', '')}.vue`
                )
            )
          ),
        } as const;
      }
      if (icon.startsWith('landrover/')) {
        return {
          type: 'component',
          icon: markRaw(
            defineAsyncComponent(
              () =>
                import(
                  `../claims-widget/components/illustration/landrover/${icon
                    .replaceAll('.vue', '')
                    .replaceAll('landrover/', '')}.vue`
                )
            )
          ),
        } as const;
      }
      if (icon.startsWith('volvo/')) {
        return {
          type: 'component',
          icon: markRaw(
            defineAsyncComponent(
              () =>
                import(
                  `../claims-widget/components/illustration/volvo/${icon
                    .replaceAll('.vue', '')
                    .replaceAll('volvo/', '')}.vue`
                )
            )
          ),
        } as const;
      }
      if (icon.startsWith('mini/')) {
        return {
          type: 'component',
          icon: markRaw(
            defineAsyncComponent(
              () =>
                import(
                  `../claims-widget/components/illustration/mini/${icon
                    .replaceAll('.vue', '')
                    .replaceAll('mini/', '')}.vue`
                )
            )
          ),
        } as const;
      }
      if (icon.startsWith('bmw/')) {
        return {
          type: 'component',
          icon: markRaw(
            defineAsyncComponent(
              () =>
                import(
                  `../claims-widget/components/illustration/bmw/${icon
                    .replaceAll('.vue', '')
                    .replaceAll('bmw/', '')}.vue`
                )
            )
          ),
        } as const;
      }
      if (icon.startsWith('toyota/')) {
        return {
          type: 'component',
          icon: markRaw(
            defineAsyncComponent(
              () =>
                import(
                  `../claims-widget/components/illustration/toyota/${icon
                    .replaceAll('.vue', '')
                    .replaceAll('toyota/', '')}.vue`
                )
            )
          ),
        } as const;
      }
      if (icon.startsWith('mopar/')) {
        return {
          type: 'component',
          icon: markRaw(
            defineAsyncComponent(
              () =>
                import(
                  `../claims-widget/components/illustration/mopar/${icon
                    .replaceAll('.vue', '')
                    .replaceAll('mopar/', '')}.vue`
                )
            )
          ),
        } as const;
      }
      if (icon.startsWith('jeep/')) {
        return {
          type: 'component',
          icon: markRaw(
            defineAsyncComponent(
              () =>
                import(
                  `../claims-widget/components/illustration/jeep/${icon
                    .replaceAll('.vue', '')
                    .replaceAll('jeep/', '')}.vue`
                )
            )
          ),
        } as const;
      }
      if (icon.startsWith('mercedes/')) {
        return {
          type: 'component',
          icon: markRaw(
            defineAsyncComponent(
              () =>
                import(
                  `../claims-widget/components/illustration/mercedes/${icon
                    .replaceAll('.vue', '')
                    .replaceAll('mercedes/', '')}.vue`
                )
            )
          ),
        } as const;
      }
      if (icon.startsWith('jlr/')) {
        return {
          type: 'component',
          icon: markRaw(
            defineAsyncComponent(
              () =>
                import(
                  `../claims-widget/components/illustration/jlr/${icon
                    .replaceAll('.vue', '')
                    .replaceAll('jlr/', '')}.vue`
                )
            )
          ),
        } as const;
      }
      if (icon.startsWith('volkswagen/')) {
        return {
          type: 'component',
          icon: markRaw(
            defineAsyncComponent(
              () =>
                import(
                  `../claims-widget/components/illustration/volkswagen/${icon
                    .replaceAll('.vue', '')
                    .replaceAll('volkswagen/', '')}.vue`
                )
            )
          ),
        } as const;
      }
      if (icon.startsWith('bentley/')) {
        return {
          type: 'component',
          icon: markRaw(
            defineAsyncComponent(
              () =>
                import(
                  `../claims-widget/components/illustration/bentley/${icon
                    .replaceAll('.vue', '')
                    .replaceAll('bentley/', '')}.vue`
                )
            )
          ),
        } as const;
      }
      if (icon.startsWith('audi/')) {
        return {
          type: 'component',
          icon: markRaw(
            defineAsyncComponent(
              () =>
                import(
                  `../claims-widget/components/illustration/audi/${icon
                    .replaceAll('.vue', '')
                    .replaceAll('audi/', '')}.vue`
                )
            )
          ),
        } as const;
      }
      if (icon.startsWith('samsung/')) {
        return {
          type: 'component',
          icon: markRaw(
            defineAsyncComponent(
              () =>
                import(
                  `../claims-widget/components/illustration/samsung/${icon
                    .replaceAll('.vue', '')
                    .replaceAll('samsung/', '')}.vue`
                )
            )
          ),
        } as const;
      }
      if (icon.startsWith('tesla/')) {
        return {
          type: 'component',
          icon: markRaw(
            defineAsyncComponent(
              () =>
                import(
                  `../claims-widget/components/illustration/tesla/${icon
                    .replaceAll('.vue', '')
                    .replaceAll('tesla/', '')}.vue`
                )
            )
          ),
        } as const;
      }
      if (icon.startsWith('aa/')) {
        return {
          type: 'component',
          icon: markRaw(
            defineAsyncComponent(
              () =>
                import(
                  `../claims-widget/components/illustration/aa/${icon.replaceAll('.vue', '').replaceAll('aa/', '')}.vue`
                )
            )
          ),
        } as const;
      }
      if (icon.startsWith('suzuki/')) {
        return {
          type: 'component',
          icon: markRaw(
            defineAsyncComponent(
              () =>
                import(
                  `../claims-widget/components/illustration/suzuki/${icon
                    .replaceAll('.vue', '')
                    .replaceAll('suzuki/', '')}.vue`
                )
            )
          ),
        } as const;
      }
      if (icon.startsWith('common/')) {
        return {
          type: 'component',
          icon: markRaw(
            defineAsyncComponent(
              () =>
                import(
                  `../claims-widget/components/illustration/common/${icon
                    .replaceAll('.vue', '')
                    .replaceAll('common/', '')}.vue`
                )
            )
          ),
        } as const;
      }
      if (icon.startsWith('cinch/')) {
        return {
          type: 'component',
          icon: markRaw(
            defineAsyncComponent(
              () =>
                import(
                  `../claims-widget/components/illustration/cinch/${icon
                    .replaceAll('.vue', '')
                    .replaceAll('cinch/', '')}.vue`
                )
            )
          ),
        } as const;
      }
      if (icon.startsWith('general/')) {
        return {
          type: 'component',
          icon: markRaw(
            defineAsyncComponent(
              () =>
                import(
                  `../claims-widget/components/illustration/general/${icon
                    .replaceAll('.vue', '')
                    .replaceAll('general/', '')}.vue`
                )
            )
          ),
        } as const;
      }
      return {
        type: 'component',
        icon: markRaw(
          defineAsyncComponent(() => import(`../claims-widget/components/illustration/${icon.replace('.vue', '')}.vue`))
        ),
      } as const;
    }
    if (icon.startsWith('volvo')) {
      return {
        type: 'volvo',
        icon: markRaw(defineAsyncComponent(() => import(`../base/VolvoIcon.vue`))),
      } as const;
    }

    if (icon.startsWith('<svg')) {
      return {
        type: 'svg',
        icon,
      } as const;
    }
    return {
      type: 'iconify',
      icon,
    } as const;
  }
</script>
